import { motion } from "framer-motion";
import { CONTACT } from "../../data";

export const WhatsAppButton = () => {
  const href = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
    "Hi CARFIX AUTO, I'd like to know more about your services."
  )}`;

  return (
    <motion.a
      data-testid="whatsapp-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.6, type: "spring", stiffness: 200, damping: 15 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[9996] flex items-center gap-3 rounded-full bg-[#25D366] px-4 py-3.5 shadow-[0_8px_30px_rgba(37,211,102,0.4)] md:bottom-8 md:right-8"
    >
      <svg
        viewBox="0 0 32 32"
        className="h-6 w-6 fill-white"
        aria-hidden="true"
      >
        <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.555 4.184 1.61 6.008L4 29l8.184-1.57a11.94 11.94 0 0 0 3.82.63h.004C22.63 28.06 28 22.676 28 16.055 28 12.84 26.75 9.82 24.48 7.55 22.21 5.28 19.22 3 16.004 3Zm0 21.86h-.003a9.9 9.9 0 0 1-3.475-.63l-.25-.093-4.855.93.93-4.735-.163-.244a9.86 9.86 0 0 1-1.51-5.28c0-5.46 4.44-9.9 9.9-9.9 2.645 0 5.13 1.03 7 2.9a9.85 9.85 0 0 1 2.9 7c0 5.46-4.44 9.9-9.9 9.9Zm5.43-7.41c-.297-.15-1.758-.868-2.03-.967-.272-.099-.47-.148-.668.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.76-1.653-2.058-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.15-.174.198-.298.297-.496.099-.198.05-.372-.025-.52-.074-.15-.668-1.612-.916-2.207-.241-.58-.486-.5-.668-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.478 0 1.462 1.065 2.875 1.213 3.073.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.29.173-1.413-.074-.124-.272-.198-.57-.347Z" />
      </svg>
      <span className="hidden font-mono text-xs font-bold uppercase tracking-[0.15em] text-white sm:block">
        WhatsApp
      </span>
    </motion.a>
  );
};
